import * as React from "react";
import Button from "@material-ui/core/Button";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Info from "../../UserMessaging/UserMessageSummaryInfoContainer";
import { UserMessage } from "../../UserMessaging/userMessageTypes";
import TopBar from "./Ops.UserMessaging.UserMessageGeneralTopBar";
import handleMutationError from "app/utils/handleMutationError";
import { fromMoment } from "app/utils/filters";
import * as moment from "moment";

type Props = {
  data: any;
  editUserMessage: any;
  history: any;
};

type State = {
  message: UserMessage;
  saving: boolean;
};

class Create extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      saving: false,
      message: {
        id: null,
        title: "",
        description: "",
        expires_at: fromMoment(moment()),
        user_targeting_type: "draft",
        version: null,
        deeplink_action: "",
        external_action: "",
        icon: "",
      },
    };
  }

  onSave = () => {
    this.setState({ saving: true });
    this.props
      .editUserMessage({
        variables: {
          title: this.state.message.title,
          description: this.state.message.description,
          expires_at: this.state.message.expires_at,
          deeplink_action:
            this.state.message.deeplink_action_path +
            this.state.message.deeplink_action_uid,
          external_action: this.state.message.external_action,
          icon: this.state.message.icon,
        },
      })
      .then((e) => {
        const mId = e.data.update_user_message.id;
        this.props.history.push(`/snapscan/ops/user_messaging/${mId}/summary`);
      })
      .catch((error) => {
        handleMutationError(error);
      })
      .finally(() => this.setState({ saving: false }));
  };

  onChangeMessage = (userMessage: UserMessage): void => {
    this.setState({ message: userMessage });
  };

  render() {
    return (
      <React.Fragment>
        <TopBar />
        <section className="padded">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              borderBottom: "1px solid #aaa",
              alignItems: "flex-end",
            }}
          >
            <h1 style={{ margin: 0 }}>Create Message</h1>
            <Button
              variant="contained"
              color="primary"
              onClick={this.onSave}
              disabled={this.state.saving}
            >
              {this.state.saving ? "Creating..." : "Create"}
            </Button>
          </div>
          <Info
            editMode={true}
            onChangeMessage={this.onChangeMessage}
            message={this.state.message}
          />
        </section>
      </React.Fragment>
    );
  }
}

const editUserMessage = graphql(
  gql`
    mutation editUserMessage(
      $title: String
      $description: String
      $expires_at: String
      $deeplink_action: String
      $external_action: String
      $icon: String
    ) {
      update_user_message(
        title: $title
        description: $description
        expires_at: $expires_at
        deeplink_action: $deeplink_action
        external_action: $external_action
        icon: $icon
      ) {
        id
      }
    }
  `,
  { name: "editUserMessage" }
);

export default compose(editUserMessage)(Create);
